// CommonMessage.js
import React from 'react';

const CommonMessage = () => {
  return (
    <div>
      <h2>Common Message</h2>
      <p>Set up your common messages for easy use in WhatsApp.</p>
    </div>
  );
};

export default CommonMessage;
